<form #form>
    <xena-alert type="primary" class="mb-4" open i18n="@@smtpSettings_information">
        Please use these settings with caution and test them regularly. If the SMTP settings are incorrect your invoices
        and other emails from Xena won't reach the recipient.
    </xena-alert>
    <div class="grid gap-4 grid-cols-4">
        <xena-switch class="col-span-full" [checked]="enabled" (checkedChange)="enabled = $event.detail"  i18n="@@enabled">Enabled</xena-switch>
        <ng-template [ngIf]="enabled">
            <xena-input class="col-span-2" label="Server" i18n-label="@@smtpSettings_server" [(ngModel)]="value.server" name="server"></xena-input>
            <xena-input type="number" label="Port" i18n-label="@@smtpSettings_port" [(ngModel)]="port" name="port"></xena-input>
            <xena-switch label-margin [(ngModel)]="value.enableSsl" i18n="@@smtpSettings_ssl" name="enableSsl">SSL/TLS</xena-switch>

            <xena-input class="col-span-2" label="Username" i18n-label="@@username" [(ngModel)]="value.username" name="username"></xena-input>
            <xena-input class="col-span-2" type="password" label="Password" i18n-label="@@password" [(ngModel)]="password" name="password"></xena-input>

            <xena-input class="col-span-4" label="From email address" i18n-label="@@smtpSettings_fromEmail"
                help-text="The standard sender address" i18n-help-text="@@smtpSettings_fromEmailHelp" 
                [(ngModel)]="value.defaultSender" name="defaultSender"></xena-input>

            <xena-input class="col-span-4" label="Administrator email" i18n-label="@@smtpSettings_adminEmail"
                help-text="Test emails and send error notifications will be sent to this email."
                i18n-help-text="@@smtpSettings_adminEmailHelp" [(ngModel)]="value.adminEmail" name="adminEmail"></xena-input>
        </ng-template>
    </div>
</form>
